/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
window.$ = window.jQuery = require('jquery');
require('bootstrap');

$(document).ready(function () {
    $("a").on('click', function(event) {
        if (this.hash !== "") {
            event.preventDefault();
            if($(this).hasClass('js-no-scroll') == false) {
                var hash = this.hash;
                if($(hash).length == 0) {
                    window.location = this.href;
                }
                if($(hash).length > 0) {
                    $('html, body').animate({
                        scrollTop: $(hash).offset().top
                    }, 800, function(){
                        window.location.hash = hash;
                    });
                }
            }
        }
    });

});

$('.carosel-control-right').click(function() {
  $(this).blur();
  $(this).parent().find('.carosel-item').first().insertAfter($(this).parent().find('.carosel-item').last());
});
$('.carosel-control-left').click(function() {
  $(this).blur();
  $(this).parent().find('.carosel-item').last().insertBefore($(this).parent().find('.carosel-item').first());
});

$("#carosel1").on("touchstart", function(event){
        var xClick = event.originalEvent.touches[0].pageX;
    $(this).one("touchmove", function(event){
        var xMove = event.originalEvent.touches[0].pageX;
        if( Math.floor(xClick - xMove) > 5 ){
            $(this).carousel('next');
        }
        else if( Math.floor(xClick - xMove) < -5 ){
            $(this).carousel('prev');
        }
    });
    $(".carosel").on("touchend", function(){
            $(this).off("touchmove");
    });
});


// WEBPACK FOOTER //
// ./resources/assets/js/app.js